module.exports = __webpack_public_path__ + "img/icon-presidents-02.5f7642cc.png";